import { render, staticRenderFns } from "./reviewfeedback.vue?vue&type=template&id=fa7cd570&scoped=true&"
import script from "./reviewfeedback.vue?vue&type=script&lang=js&"
export * from "./reviewfeedback.vue?vue&type=script&lang=js&"
import style0 from "./reviewfeedback.vue?vue&type=style&index=0&id=fa7cd570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7cd570",
  null
  
)

export default component.exports